/* import __COLOCATED_TEMPLATE__ from './video-splash.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface VideoSplashSignature {
  Args: {
    isActive: boolean;
    headline: string;
    description: string;
    ctaLabel: string;
    openUpgradeModal: () => void;
    learnMoreArticleId: number;
    subHeading: string;
    videoId?: string;
    thumbnailUrl?: string;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class VideoSplash extends Component<VideoSplashSignature> {
  @tracked videoStarted = false;

  get showIframe() {
    return !this.args.thumbnailUrl || this.videoStarted;
  }

  get showThumbnailOverlay() {
    return !!this.args.thumbnailUrl && !this.videoStarted;
  }

  get wistiaUrl() {
    let autoPlay = this.videoStarted ? 'true' : 'false';
    return `https://fast.wistia.net/embed/iframe/${this.args.videoId}?videoFoam=true&playerColor=1d364b&autoPlay=${autoPlay}&controlsVisibleOnLoad=false&videoQuality=hd-only&smallPlayButton=true&playButton=true&fullscreenButton=true`;
  }

  @action
  startVideo() {
    this.videoStarted = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Paywalls::VideoSplash': typeof VideoSplash;
  }
}
